import { render } from "./ClientSpacePurchase.vue?vue&type=template&id=a966ab48&scoped=true"
import script from "./ClientSpacePurchase.vue?vue&type=script&lang=js"
export * from "./ClientSpacePurchase.vue?vue&type=script&lang=js"

import "@/assets/scss/_clientSpaceResume.scss?vue&type=style&index=0&id=a966ab48&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a966ab48"]])

export default __exports__